/**
 * Checked reads from arrays. With `noUncheckedIndexedAccess` every read may be `undefined`; the layout
 * loops only read inside the bounds they check, and this turns a read outside them into an error instead of
 * a silent zero.
 */

/** The element at `index`; throws a RangeError outside the array. */
export function at<T>(array: ArrayLike<T>, index: number): T {
  const value = array[index];
  if (value === undefined) throw new RangeError(`index ${index} is outside an array of ${array.length}`);
  return value;
}

/** The value under `key`; throws a RangeError when the map has none. */
export function entry<K, V>(map: ReadonlyMap<K, V>, key: K): V {
  const value = map.get(key);
  if (value === undefined) throw new RangeError(`no entry for ${String(key)}`);
  return value;
}
